import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-iqaccontent-create',
  templateUrl: './iqaccontent-create.component.html',
  styleUrls: ['./iqaccontent-create.component.scss']
})
export class IqaccontentCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  headings = [];
  subheadings = [];

  ngOnInit() {
    this.Form = this.formBuilder.group({
      heading: ['', Validators.required],
      headingname: [''],
      subheading: ['', Validators.required],
      subheadingname: [''],
      content: ['', [Validators.required]],
      _id: [''],
      seohidden: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/iqaccontentbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.http.get<any>(this.api_endpoint+'/iqacgetsubheadingbyheading/' + data.data.heading).subscribe(
              data => {
                this.subheadings = data.data
            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
          });
            this.Form.patchValue({
              heading: data.data.heading,
              headingname: data.data.headingname,
              subheading: data.data.subheading,
              subheadingname: data.data.subheadingname,
              content: data.data.content,
              _id: data.data._id,
              seohidden:data.data.seohidden
            })
            
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              heading: '',
              headingname: '',
              subheading: '',
              subheadingname: '',
              content: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
  });
  this.http.get<any>(this.api_endpoint+'/iqacheading/').subscribe(
    data => {
      this.headings = data.data
  },
  (err: HttpErrorResponse) => {
    if (err.error instanceof Error) {
      console.log("Client-side error occured.");
    } else {
      console.log("Server-side error occured.");
    }
});
  }

  getheading(value){
    this.http.get<any>(this.api_endpoint+'/iqacheadingbyid/' + value).subscribe(
        data => {
          this.Form.patchValue({
            headingname: data.data.heading,
          })
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
      this.http.get<any>(this.api_endpoint+'/iqacgetsubheadingbyheading/' + value).subscribe(
          data => {
            this.subheadings = data.data;
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
      });
  }
  getsubheading(value){
    this.http.get<any>(this.api_endpoint+'/iqacsubheadingbyid/' + value).subscribe(
        data => {
          this.Form.patchValue({
            subheadingname: data.data.subheading,
          })
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "heading"      : this.Form.value.heading,
        "headingname"      : this.Form.value.headingname,
        "subheading"      : this.Form.value.subheading,
        "subheadingname"      : this.Form.value.subheadingname,
        "content"  : this.Form.value.content,
        "admin" : sessionStorage.getItem('adminName'),
        "_id"           : this.Form.value._id,
        "seohidden": this.Form.value.seohidden
      };
      this.http.put<any>(this.api_endpoint+'/iqaccontent', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/iqaccontent/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "heading"      : this.Form.value.heading,
        "headingname"      : this.Form.value.headingname,
        "subheading"      : this.Form.value.subheading,
        "subheadingname"      : this.Form.value.subheadingname,
        "content"  : this.Form.value.content,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden": this.Form.value.seohidden
      };
      this.http.post<any>(this.api_endpoint+'/iqaccontent', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/iqaccontent/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
